<template>
  <v-tooltip
    top
    max-width="320"
  >
    <template #activator="{ on, attrs }">
      <span
        class="brief-action-tooltip"
        v-bind="attrs"
        v-on="on"
      >
        <slot />
      </span>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        name: 'BriefActionTooltip',
        props: {
            text: {
                type: String,
                required: true
            }
        }
    });
</script>

<style scoped lang="sass">
.brief-action-tooltip
    display: inline-flex
    max-width: 100%
    vertical-align: middle
</style>
